export const getAreas = (state) => state.areas
